import { ChatWithDataMinMaxProposalRow } from '@recurrency/core-api-schema/dist/chatWithData/chatWithData';

/** Mirrors the midpoint calculation core-api uses when it builds the proposal. */
export function getProjectedInventoryChange(
  row: Pick<ChatWithDataMinMaxProposalRow, 'currentMin' | 'currentMax' | 'unitCost'>,
  newMin: number,
  newMax: number,
) {
  const currentMid = ((row.currentMin ?? 0) + (row.currentMax ?? 0)) / 2;
  return ((newMin + newMax) / 2 - currentMid) * (row.unitCost ?? 0);
}

export function getTotalInventoryChange(rows: ChatWithDataMinMaxProposalRow[]) {
  return rows.reduce((sum, row) => sum + row.projectedInventoryChange, 0);
}

export function isValidMinMax(newMin: number | undefined, newMax: number | undefined) {
  return newMin !== undefined && newMax !== undefined && newMin >= 0 && newMax >= newMin;
}
